import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../store';
import {
  IonPage, IonButton, IonButtons, IonContent, IonBackButton,
  IonHeader, IonIcon, IonTitle, IonToolbar,
} from '@ionic/react';
// import AboutPopover from '../components/AboutPopover';
import { Plugins } from '@capacitor/core';
import './About.css';


type Props = ReturnType<typeof mapStateToProps>

type State = {
  showPopover: boolean,
  showPopoverEvent: null | MouseEvent
}

class About extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showPopover: false,
      showPopoverEvent: null
    };
  }
  componentDidMount() {
    try {
        let adsbygoogle;
        // @ts-ignore
        (adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }

  presentPopover = (e: MouseEvent) => {
    this.setState(() => ({
      showPopover: true,
      showPopoverEvent: e
    }));
  };

  dismissPopover = () => {
    this.setState(() => ({
      'showPopover': false,
      'showPopoverEvent': null
    }));
  };
  render() {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="profile" />
            </IonButtons>
            <IonTitle>About</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
            <div className="about-header">
                <img src="assets/img/parklers.png" alt="Parklers"/>
            </div>
            <div className="ion-padding about-info">
                <h4>National Parks Passport Book</h4>
                <br />
                <p>
                    This app will help you find information about National Parks and help you maintain a list for what you have visited and favorited and your next bucket list. 
                    Data is from the National Park Service (https://www.nps.gov/subjects/developer/api-documentation.htm#/). Huge thanks to National Park Service.
                    Credits for all the images and data all goes to National Park Service. 

                    <br/> <br/>
                    For more information go to https://www.nps.gov/index.htm 
                    <br/> <br/>
                    This app is also available on a web app. <a href="https://www.parklers.com">https://www.parklers.com</a>
                    <br/> <br/>
                    Please rate and comment.  Any feedback will be great.
                    <br /><br />
                    Donations are also welcomed to help me keep the service up.
                </p>
                <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                <input type="hidden" name="cmd" value="_donations" />
                <input type="hidden" name="business" value="M8MKDUXW862GQ" />
                <input type="hidden" name="currency_code" value="USD" />
                <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                <img alt="" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
                </form>
                <br />
                <div>
                    <b>Version:</b> v{this.props.version.version}({this.props.version.versionCode})<br />
                    <b>Released Date:</b> {this.props.version.releasedDate}<br />
                </div>
            </div>
            <ins className="adsbygoogle"
            style={{display:'block'}}
            data-ad-client="ca-pub-2796376641761374"
            data-ad-slot="1578893839"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
        </IonContent>
      </IonPage>
      );
    }
}

const mapStateToProps = (state: RootState) => ({
  version: state.app.installed,
});

export default connect(
  mapStateToProps
)(About);
